export const boxShadows = {
  small: { boxShadow: `0px 4px 16px 0px rgba(0, 0, 0, 0.12)` },
  large: { boxShadow: `0px 1px 2px 0px rgba(0, 0, 0, 0.16)` },
  modal: { boxShadow: `0px 0px 4px 0px rgba(0, 0, 0, 0.2)` },
  norlys: { boxShadow: `0px 10px 50px 0px rgba(0, 0, 0, 0.2)` },
  norlysButton: { boxShadow: `4px 8px 15px 0px rgba(0, 0, 0, 0.2)` },
  mobileBodil: { boxShadow: `0px 2px 8px 0px rgba(0, 0, 0, 0.2)` },
};
